import React, { forwardRef } from 'react';

/**
 * Textarea Component
 * A reusable textarea with label, error state, and dark mode support
 */
const Textarea = forwardRef(({
  label,
  error,
  className = '',
  containerClassName = '',
  required = false,
  disabled = false,
  rows = 3,
  resize = 'vertical',
  ...props
}, ref) => {
  const baseTextareaStyles = `
    w-full px-3 py-2 
    border rounded-lg
    text-gray-900 dark:text-gray-100
    bg-white dark:bg-gray-800
    border-gray-300 dark:border-gray-600
    placeholder-gray-400 dark:placeholder-gray-500
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
    disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:cursor-not-allowed
    transition-colors duration-200
  `;

  const resizeStyles = {
    none: 'resize-none',
    vertical: 'resize-y',
    horizontal: 'resize-x',
    both: 'resize',
  };

  const errorStyles = error ? 'border-red-500 dark:border-red-400 focus:ring-red-500' : '';

  return (
    <div className={`mb-4 ${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-white dark:text-white mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        disabled={disabled}
        className={`${baseTextareaStyles} ${resizeStyles[resize]} ${errorStyles} ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-500 dark:text-red-400">{error}</p>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;

